import { createApp } from 'vue'
import { globalRegister } from './global'
import 'normalize.css'
import './assets/css/index.less'
import '@/assets/styles/index.scss'

import App from './App.vue'

import router from './router'
import store from './store'
import { setUpState } from './store'
import directive from './directive' // directive
import registerIcons from './assets/icons' // 导入SVG图标注册函数
import './permission' // permission control

import { getDicts } from "@/service/main/system/dict";  
// 全局方法挂载
const app = createApp(App)
app.config.globalProperties.getDicts = getDicts

// 注册element-plus/其他
app.use(globalRegister)
//获取初始化vuex登录数据
setUpState() //需要再注册router之前，否则刷新后匹配到的是notFound页面（先匹配，后动态注册,所以匹配到了notfound）
app.use(store)
app.use(router)
app.use(directive)
registerIcons(app) // 注册SVG图标
app.mount('#app')

// console.log(VUE_APP_BASE_URL)
// console.log(process.env.VUE_APP_BASE_URL)
// console.log(process.env.VUE_APP_BASE_NAME)
